import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
/////////////////////////////////////////////////////////////
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
import { telegramWebApp } from '@/main';
import { Activity } from '@/core/interfaces';
import {
	ActivityDetail,
	FoundComboCardDialog,
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@/app/shared/components';
import { setShowDrawerDailyComboFound } from '@/core/redux/slices';
import { ActivityItem, SpecialActivityItem } from './components';

export const Categories: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const dispatch = useCustomDispatch();
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { categories, showDrawerFoundDailyCombo } = useCustomSelector(
		(state) => state.categories
	);

	/*********************
	// #region Constants
	**********************/
	const deviceHeight = telegramWebApp.viewportHeight;

	/*********************
	// #region States
	**********************/
	const [selectedActivity, setSelectedActivity] = useState<Activity>();
	const [visibleDrawerActivity, setVisibleDrawerActivity] =
		useState<boolean>(false);
	const [visibleDialogComboFound, setVisibleDialogComboFound] =
		useState<boolean>(false);

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		if (!showDrawerFoundDailyCombo) return;
		setVisibleDialogComboFound(true);
	}, [showDrawerFoundDailyCombo]);

	/*********************
	// #region Functions
	**********************/
	const handleCloseDialog = () => {
		// console.log(showDrawerFoundDailyCombo);
		setVisibleDialogComboFound(false);
		dispatch(setShowDrawerDailyComboFound(false));
	};

	/*********************
	// #region Template
	**********************/
	return (
		<div
			className="mt-6"
			style={{
				minHeight: `calc(${deviceHeight}px - 205px)`,
			}}
		>
			<Tabs defaultValue={categories[0].id} className="w-[100%]">
				<TabsList className="w-[100%] bg-transparent">
					{categories.map((category, key) => {
						if (category.activities.length > 0) {
							return (
								<TabsTrigger
									key={category.id}
									value={category.id}
									className="flex-1 data-[state=active]:bg-customer-800/40 data-[state=active]:text-customer-500 py-3 rounded-xl text-white"
								>
									{t(`categories.tabs.${key}`)}
								</TabsTrigger>
							);
						}
						return null; // Return null if the condition is not met
					})}
					{/* <TabsTrigger
						value={'luck'}
						className="flex-1 data-[state=active]:bg-customer-800/40 data-[state=active]:text-customer-300 py-3 rounded-xl text-white"
					>
						{t(`categories.tabs.Luck`)}
					</TabsTrigger> */}
				</TabsList>

				{categories.map((category, indexCategory) => {
					return (
						<TabsContent key={category.id} value={category.id}>
							{category.name === 'Special' ? (
								<div className="grid grid-cols-2 gap-3">
									{category.activities.map((activity) => {
										return (
											<SpecialActivityItem
												key={activity.id}
												activity={activity}
												onClickActivity={(
													activity,
													drawerVisiblity
												) => {
													setSelectedActivity(
														activity
													);
													setVisibleDrawerActivity(
														drawerVisiblity
													);
												}}
											/>
										);
									})}
								</div>
							) : (
								<div className="flex flex-col gap-3">
									{category.activities.map((activity) => {
										return (
											<ActivityItem
												key={activity.id}
												activity={activity}
												categoryIndex={
													indexCategory + 1
												}
												onClickActivity={(
													activity,
													drawerVisiblity
												) => {
													setSelectedActivity(
														activity
													);
													setVisibleDrawerActivity(
														drawerVisiblity
													);
												}}
											/>
										);
									})}
								</div>
							)}
						</TabsContent>
					);
				})}

				{/* <TabsContent value="luck">
					<div className="border flex justify-center items-center pb-5 rounded-2xl bg-customer-950/60 mt-8">
						<img src={Roulette} className="blur-sm opacity-25" />
						<div className="flex flex-col absolute items-center space-y-5">
							<LockIcon size="64px" />

							<p className="text-lg font-semibold text-yellow-400">
								Coming soon...
							</p>
						</div>
					</div>
				</TabsContent> */}
			</Tabs>

			{selectedActivity && (
				<ActivityDetail
					isOpen={visibleDrawerActivity}
					onClose={setVisibleDrawerActivity}
					activity={selectedActivity}
				/>
			)}

			{visibleDialogComboFound && (
				<FoundComboCardDialog
					isOpen={visibleDialogComboFound}
					onClose={handleCloseDialog}
				/>
			)}
		</div>
	);
};
